import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import Modalheader from '../../../components/header';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import Button from '../../../../button';
import JustificatifConfirmation from 'components/justificatifConfirmation/JustificatifConfirmation';
import useJustificatifConfirmation from 'hooks/useJustificatifConfirmation';

const ModalConfirmPaymentSettings = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const justificatif = useJustificatifConfirmation();

  const confirm = () => {
    // Uploaded here, not on selection: closing this modal must leave nothing
    // stored, and nothing applied.
    justificatif.confirm((storedJustificatif) => {
      setModalDataReturn({
        type: 'payment_settings_confirmed',
        coefficients: modalData?.coefficients,
        justificatif: storedJustificatif,
        // The panel no longer carries an attestation of its own: this one is
        // it, and the API refuses a save that arrives without it.
        attested: true,
      });
      toggle();
    });
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Confirmer les paramètres de paiement
      </Modalheader>
      <ModalBody>
        <div className={'flex flex-col gap-4'}>
          {/* The grid decides what the client is billed, so the change is
              backed by the client's written request for it — a document, not
              only the declaration already given on the page behind. */}
          <JustificatifConfirmation
            file={justificatif.file}
            setFile={justificatif.setFile}
            isAttested={justificatif.isAttested}
            setIsAttested={justificatif.setIsAttested}
            error={justificatif.error}
            description={
              'Ces coefficients déterminent la facturation de l’entreprise. Un justificatif est requis avant validation.'
            }
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
          Annuler
        </Button>
        <Button
          size={'LG'}
          color={
            justificatif.canConfirm && !justificatif.isUploading
              ? 'PRIMARY'
              : 'DISABLED'
          }
          onClick={confirm}
        >
          {justificatif.isUploading ? 'Confirmation ...' : 'Confirmer'}
        </Button>
      </ModalFooter>
    </>
  );
};

export default ModalConfirmPaymentSettings;
